import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { Button as AntButton, Descriptions, Modal } from 'antd';
import Radio from '../../../Radio';
import useAxios from "../../../../hooks/useAxios";
import useNotification from "../../../../hooks/useNotification";
import { useSelector } from "react-redux";
import { RootState } from "../../../../store/rootReducer";
import { createTemplate, updateTemplate } from "../../../../api/template.api";
import Loader from "../../../Loader";
import ErrorResponse from "../../../ErrorResponse";
import { ITemplate } from "../../../../models/template.model";

interface IProps {
  visible: boolean;
  setVisible: (visible: boolean) => void;
  doGetTemplates: () => void;
  template: ITemplate | undefined;
  setTemplate: (template: ITemplate | undefined) => void;
}

const EditTemplateModal: FC<IProps> = ({
  visible, setVisible, doGetTemplates, template, setTemplate
}) => {
  const { t } = useTranslation();
  const { auth } = useSelector((state: RootState) => state.auth);
  const { infoNotification, successNotification } = useNotification();
  const { data: res, isLoading, error, execute } = useAxios();

  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [sendType, setSendType] = useState<'GE' | 'AD'>('GE');

  useEffect(() => {
    if (res && !isLoading) {
      doGetTemplates();
      onClose();
      successNotification(t('common.message.save1'));
    }
  }, [res, isLoading]);

  useEffect(() => {
    if (template) {
      setTitle(template.title);
      setContent(template.content);
      setSendType(
        template.sendType === '광고'
          ? 'AD'
          : template.sendType === 'Ad'
            ? 'AD'
            : 'GE'
      );
    }
  }, [template]);

  const onSubmit = () => {
    if (!title) {
      return infoNotification(t('student.student.message15'));
    }
    if (!content) {
      return infoNotification(t('student.student.message56'));
    }

    const req = {
      title,
      content,
      sendType,
      memberCode: auth.memberCode,
    };

    template
      ? execute(updateTemplate(template.templateCode, req))
      : execute(createTemplate(req));
  }

  const onClose = () => {
    setTemplate(undefined);
    setTitle('');
    setContent('');
    setSendType('GE');
    setVisible(false);
  }

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        title={t('sms.send.button4')}
        visible={visible}
        onCancel={onClose}
        footer={[
          <div className='comm-btn__area justify-content-center'>
            <AntButton
              key="submit"
              className='btn-basic pink'
              onClick={() => onSubmit()}
            >
              {t('common.button.save')}
            </AntButton>
            <AntButton
              key="cancel"
              onClick={onClose}
              className='btn-basic gray'
            >
              {t('common.button.cancel')}
            </AntButton>
          </div>
        ]}
      >
        <div className='comm-table__area rowType edit mt-0'>
          <Descriptions
            bordered
            size="small"
            column={1}
            labelStyle={{ width: '25%', textAlign: 'center' }}
          >
            <Descriptions.Item label={t('common.column.title')}>
              <input
                type="text"
                className="form-control"
                value={title}
                onChange={e => setTitle(e.target.value)}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('common.column.contents')}>
              <textarea
                className="w-100"
                rows={5}
                value={content}
                onChange={e => setContent(e.target.value)}
              />
            </Descriptions.Item>
            <Descriptions.Item label={t('sms.list.column2')}>
              <Radio
                checked={sendType === 'GE'}
                onChange={() => setSendType('GE')}
                text={t('student.student.option20')}
              />
              <Radio
                className="ml-4"
                checked={sendType === 'AD'}
                onChange={() => setSendType('AD')}
                text={t('student.student.option21')}
              />
            </Descriptions.Item>
          </Descriptions>
        </div>
      </Modal>
    </>
  );
}

export default EditTemplateModal;
